<template>
  <div>
    <div class="index-nav clearfix text-center">
      <div class=" col-md-offset-2 col-md-2">
        <h5>蓝牙超高频小精灵</h5>
        <ul>
          <li>
            <router-link :to="{path:'/BU/01',query:{index: 0}}">BU01</router-link>
          </li>
          <li>
            <router-link :to="{path:'/BU/01KB',query: {index: 1}}">BU01KB</router-link>
          </li>
          <li>
            <router-link :to="{path:'/BU/01PB',query: {index: 2}}">BU01PB</router-link>
          </li>
        </ul>
      </div>
      <div class="col-md-2">
        <h5>蓝牙高频小精灵</h5>
        <ul>
          <li>
            <router-link :to="{path:'/BH/04',query: {index: 0}}">BH04</router-link>
          </li>

          <li>
            <router-link :to="{path:'/BH/04KB', query: {index: 1}}">BH04KB</router-link>
          </li>
        </ul>
      </div>
      <div class="col-md-2">
        <h5>音频口超高频小精灵</h5>
        <ul>
          <li>
            <router-link :to="{path:'/RU/02', query: {index: 0}}">RU02</router-link>
          </li>
          <li>
            <router-link :to="{path:'/RU/03', query: {index: 1}}">RU03</router-link>
          </li>
        </ul>
      </div>
      <div class="col-md-2">
        <h5>音频口高频小精灵</h5>
        <ul>
          <li>
            <router-link :to="{path:'/RH/06', query: {index: 0}}">RH06</router-link>
          </li>
          <li>
            <router-link :to="{path:'/RH/07', query: {index: 1}}">RH07</router-link>
          </li>
          <li>
            <router-link :to="{path:'/RH/21', query: {index: 2}}">RH21</router-link>
          </li>
        </ul>
      </div>
      <div class="col-md-2">
        <h5>扫描枪</h5>
        <ul>
          <li>
            <router-link :to="{path:'/SMQ/02',query: {index: 0}}">BU02</router-link>
          </li>
          <li>
            <router-link :to="{path:'/SMQ/02PB',query: {index: 1}}">BU02PB</router-link>
          </li>
        </ul>
      </div>
    </div>
    <footer>@2019 厦门英诺尔信息科技硬件部</footer>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  components: {}
};
</script>

<style lang="stylus" scoped rel="stylesheet/stylus"></style>



// WEBPACK FOOTER //
// src/base/footer.vue